var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSidebarNav2(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 36,
    viewBox: "0 0 40 36",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Nav-tabs"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Frame"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M17.5 10.5H13.3333C12.8731 10.5 12.5 10.8731 12.5 11.3333V17.1667C12.5 17.6269 12.8731 18 13.3333 18H17.5C17.9602 18 18.3333 17.6269 18.3333 17.1667V11.3333C18.3333 10.8731 17.9602 10.5 17.5 10.5Z",
    stroke: "black",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M26.6666 10.5H22.5C22.0397 10.5 21.6666 10.8731 21.6666 11.3333V13.8333C21.6666 14.2936 22.0397 14.6667 22.5 14.6667H26.6666C27.1269 14.6667 27.5 14.2936 27.5 13.8333V11.3333C27.5 10.8731 27.1269 10.5 26.6666 10.5Z",
    stroke: "black",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_3",
    d: "M26.6666 18H22.5C22.0397 18 21.6666 18.3731 21.6666 18.8333V24.6667C21.6666 25.1269 22.0397 25.5 22.5 25.5H26.6666C27.1269 25.5 27.5 25.1269 27.5 24.6667V18.8333C27.5 18.3731 27.1269 18 26.6666 18Z",
    stroke: "black",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_4",
    d: "M17.5 21.3333H13.3333C12.8731 21.3333 12.5 21.7063 12.5 22.1666V24.6666C12.5 25.1268 12.8731 25.4999 13.3333 25.4999H17.5C17.9602 25.4999 18.3333 25.1268 18.3333 24.6666V22.1666C18.3333 21.7063 17.9602 21.3333 17.5 21.3333Z",
    stroke: "black",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSidebarNav2);
export default __webpack_public_path__ + "static/media/sidebar-nav-2.4f7f9aca5f5e767cfaae425a2050fa6a.svg";
export { ForwardRef as ReactComponent };